import React from "react";
import img from "../../assets/icons/archive.svg";
import { WrapperDelete } from "./style";
import Button from "../FormElement/Button";
import { useHideModal } from "../../hooks";

function DeleteModal({ onClick }) {
  const { hideModal } = useHideModal();
  return (
    <div>
      <WrapperDelete>
        <img src={img} alt="" />
        <div className="text">
          <h2>Bo’lim arxivga o’tkazilsinmi?</h2>
        </div>
        <div className="buttons">
          <Button
            text={"Rad etish"}
            onClick={() => hideModal()}
            background="#BBBDC6"
          />
          <Button text={"Arxivga"} background="#6959DE" onClick={onClick} />
        </div>
      </WrapperDelete>
    </div>
  );
}

export default DeleteModal;
